if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.setaInitials = this.form.querySelector('[data-seta-initials]');
        if (this.setaInitials) {
          this.setaInitials.hidden = false;
          const toggle = this.setaInitials.querySelector('[data-seta-toggle]');
          toggle.addEventListener('change', () => {
            this.setaInitials.querySelector('[data-seta-fields]').hidden = !toggle.checked;
            this.form.querySelectorAll('.shopify-payment-button').forEach((button) => {
              button.hidden = toggle.checked;
              button.style.display = toggle.checked ? 'none' : '';
            });
          });
        }

      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        const setaSelected = this.setaInitials?.querySelector('[data-seta-toggle]').checked;
        const setaTexts = setaSelected
          ? Array.from(this.setaInitials.querySelectorAll('[data-seta-text]')).map((input) => ({ input, value: input.value.trim() }))
          : [];
        if (setaSelected && !setaTexts[0].value) {
          this.handleErrorMessage(this.setaInitials.dataset.requiredMessage);
          setaTexts[0].input.focus();
          return;
        }
        this.error = false;


        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        if (setaSelected) {
          const parentId = Number(formData.get('id'));
          const quantity = Number(formData.get('quantity') || 1);
          const properties = {};
          for (const [key, value] of formData.entries()) {
            const match = key.match(/^properties\[(.*)\]$/);
            if (match) properties[match[1]] = value;
          }
          properties._seta_group = crypto.randomUUID();
          const parent = { id: parentId, quantity, properties };
          if (formData.get('selling_plan')) parent.selling_plan = formData.get('selling_plan');
          const items = [parent];
          for (const { input, value } of setaTexts) {
            if (!value) continue;
            items.push({
              id: Number(this.setaInitials.dataset.feeId), quantity, parent_id: parentId,
              properties: {
                [this.setaInitials.dataset.propertyLabel]: value,
                _seta_service: 'initials', _seta_slot: input.dataset.slot,
                _seta_group: properties._seta_group,
              },
            });
          }
          const payload = { items };
          if (formData.get('sections')) payload.sections = formData.get('sections');
          if (formData.get('sections_url')) payload.sections_url = formData.get('sections_url');
          config.headers['Content-Type'] = 'application/json';
          config.body = JSON.stringify(payload);
        }


        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (setaSelected || !this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
            if (setaSelected) this.handleErrorMessage(this.setaInitials.dataset.errorMessage);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
